// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable no-nested-ternary */
import styled, { css } from 'styled-components/macro';

const MetricModalHolder = styled.div`
    width: 325px;
    min-height: 200px;
    margin: 0 32px 28px 0;
    padding: 24px;
    background-color: ${({ theme, overall }) =>
        overall ? theme.color.metric.yellow : theme.color.white};
    border-radius: ${({ theme }) => theme.border.radiusBase};
    border: 1px solid ${({ overall }) => (overall ? '#D8DADC' : '#E7F0F7')};
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    strong {
        margin-bottom: 12px;
        font-weight: 600;
    }

    span {
        color: ${({ theme }) => theme.color.textLight};
    }

    ${({ withChart }) =>
        withChart &&
        css`
            flex-direction: row;
            align-items: flex-start;
        `}

    @media (max-width: ${({ theme }) => `${theme.breakpoints.small}px`}) {
        width: 100%;
        min-width: 288px;
        margin-right: 0;
    }
`;

export const TitleHolder = styled.div`
    display: flex;
    flex-direction: column;

    strong,
    span {
        margin-bottom: 16px;
        padding-right: 5px;
    }
`;

export const Stats = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: auto;
    gap: 14px;
`;

export const Scoring = styled.div`
    color: ${({ theme }) => theme.color.textBase};
    font-size: 18px;
    margin-right: 16px;
`;

export const Indicator = styled.div`
    width: 100%;
    height: 34px;
    border-radius: ${({ theme }) => theme.border.radiusBase};
    background-color: ${({ theme }) => theme.color.bgSearch};
    position: relative;
`;

export const IndicatorProgress = styled.div`
    height: 100%;
    border-radius: ${({ theme }) => theme.border.radiusBase};
    position: relative;

    span {
        position: absolute;
        left: 20px;
        top: 8px;
        color: ${({ theme }) => theme.color.white};
        font-size: ${({ theme }) => theme.fontSize.medium};
        margin-left: 8px;
    }

    ${({ scoring }) => css`
        width: ${scoring}%;
    `};

    ${({ efficient, theme }) => css`
        background-color: ${efficient
            ? theme.color.metric.green
            : theme.color.metric.red};
    `};
`;

export const IndicatorGoal = styled.div`
    position: absolute;
    top: 48px;
    z-index: 1;

    &::before {
        content: '';
        position: absolute;
        top: -48px;
        left: 0px;
        height: 34px;
        width: 1px;
        border-left: 1px dashed ${({ theme }) => theme.color.grey};
    }

    &::after {
        content: 'ˆ';
        position: absolute;
        font-size: 18px;
        top: -14px;
        left: -3px;
    }

    ${({ goal }) =>
        css`
            left: ${goal}%;
        `};

    span {
        position: relative;
        left: -13px;
    }
`;

export default MetricModalHolder;
